module.exports = __webpack_public_path__ + "static/img/zasilacz.4b4aceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/urzadzenia_KOPIA/zasilacz.png
// module id = NgZO
// module chunks = 1